import { MbscModule } from '@mobiscroll/angular';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MetaService } from './_services/meta.service';
import { CookieModule } from 'ngx-cookie';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ScriptLoaderService } from './_services/script-loader.service';
import { AlertModule} from './modules/alert/alert.module';
//import { HttpClientModule } from '@angular/common/http';
import { HttpWithInjectorModule} from './modules/http-with-injector/http-with-injector.module';
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [ 
    MbscModule,  
    FormsModule,  
    //HttpClientModule,
    
    
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    NgbModule,
    AppRoutingModule,
    CookieModule.forRoot(),
    HttpWithInjectorModule.forRoot({endPoint: ''}),
    AlertModule.forRoot({main: 'something'})
    
  ],
  providers: [MetaService,ScriptLoaderService],
  bootstrap: [AppComponent]
})
export class AppModule { }
